import React from "react";
import { Row, Col } from "react-bootstrap";

import MSIB from "../../Assets/MSIB.png";
import PMM4 from "../../Assets/PMM.png";
import GDSC from "../../Assets/GDSC.png";
import SocialContribution from "../../Assets/SocialContribution.png";
import Festival from "../../Assets/Festival.jpeg";

function OtherExperience() {
  return (
    <section className="another-exp-section">
      <p className="another-subtitle">
        Throughout my academic journey, I have actively participated in
        leadership programs, student organizations, community engagement, and
        nationally recognized internship initiatives. These experiences have
        strengthened not only my technical expertise but also my communication,
        leadership, teamwork, and problem-solving skills in diverse
        environments.
      </p>

      <Row className="g-4 justify-content-center">
        {/* ================= MSIB ================= */}
        <Col lg={6}>
          <div className="another-card">
            <div className="another-image">
              <img src={MSIB} alt="MSIB Telkomsel" />
            </div>

            <h3>Magang & Studi Independen Bersertifikat (MSIB)</h3>

            <h5 className="experience-role">
              Software Engineer Intern – PT Telkomsel
            </h5>

            <div className="experience-info">
              <span>Medan, Indonesia</span>

              <span>September 2024 – December 2024</span>
            </div>

            <p>
              Successfully completed the MSIB program as a Software Engineer
              Intern at PT Telkomsel, where I collaborated with professional
              engineers in developing enterprise-level web applications.
              Contributed to dashboard development, database optimization, and
              business process automation while gaining valuable experience in
              Agile development, software engineering best practices, and
              collaborative project execution within a large-scale technology
              company.
            </p>
          </div>
        </Col>

        {/* ================= PMM ================= */}
        <Col lg={6}>
          <div className="another-card">
            <div className="another-image">
              <img src={PMM4} alt="PMM Batch 4" />
            </div>

            <h3>Pertukaran Mahasiswa Merdeka (PMM) Batch 4</h3>

            <h5 className="experience-role">Media & Information Coordinator</h5>

            <div className="experience-info">
              <span>Malang, East Java</span>

              <span>February 2024 – July 2024</span>
            </div>

            <p>
              Led the Publication, Decoration, and Documentation Division by
              coordinating creative campaigns and digital publications
              throughout the PMM program. Managed content planning, produced
              more than 150 Instagram feed designs, created over three Reels
              every week, and supervised documentation activities to strengthen
              participant engagement, program branding, and public
              communication.
            </p>
          </div>
        </Col>

        {/* ================= GDSC ================= */}
        <Col lg={6}>
          <div className="another-card">
            <div className="another-image">
              <img src={GDSC} alt="Google Developer Student Clubs" />
            </div>

            <h3>Google Developer Student Clubs (GDSC)</h3>

            <h5 className="experience-role">Media & Information Coordinator</h5>

            <div className="experience-info">
              <span>Medan, Indonesia</span>

              <span>January 2023 – February 2024</span>
            </div>

            <p>
              Coordinated the Media and Information Division by developing
              creative concepts, producing digital content, and managing
              communication strategies for various technology events.
              Collaborated with multimedia teams to create engaging graphics,
              videos, social media campaigns, and promotional materials while
              maintaining consistent branding and increasing audience
              interaction.
            </p>
          </div>
        </Col>

        {/* ================= SOCIAL ================= */}
        <Col lg={6}>
          <div className="another-card">
            <div className="another-image">
              <img src={SocialContribution} alt="Community Service Project" />
            </div>

            <h3>Community Service Project</h3>

            <h5 className="experience-role">
              UMKM Business Development Volunteer
            </h5>

            <div className="experience-info">
              <span>Pujon Kidul, Malang</span>

              <span>May 2024</span>
            </div>

            <p>
              Participated in a social contribution program focused on
              empowering local MSMEs through branding and digital
              transformation. Assisted business owners in improving product
              packaging, creating attractive promotional content, developing
              product photography techniques, and introducing digital marketing
              strategies to enhance product visibility and business
              competitiveness in the online marketplace.
            </p>
          </div>
        </Col>

        {/* ================= CULTURAL FESTIVAL ================= */}

        <Col lg={6}>
          <div className="another-card">
            <div className="another-image">
              <img src={Festival} alt="Cultural Festival 2024" />
            </div>

            <h3>Cultural Festival 2024</h3>

            <h5 className="experience-role">
              Coordinator of Publication, Decoration & Documentation Division
            </h5>

            <div className="experience-info">
              <span>Universitas Muhammadiyah Malang</span>

              <span>June 2024</span>
            </div>

            <p>
              Selected as the Coordinator of the Publication, Decoration, and
              Documentation Division for Cultural Festival 2024. Led the
              planning and execution of the festival's visual concept,
              coordinated promotional activities, supervised decoration design
              and implementation, and managed photography and videography teams
              to document the event. Collaborated with the organizing committee
              to create engaging promotional content while showcasing the
              richness and diversity of Indonesian cultural heritage.
            </p>
          </div>
        </Col>
      </Row>
    </section>
  );
}

export default OtherExperience;
